import { render, staticRenderFns } from "./ForecastCardToxinParams.vue?vue&type=template&id=5160b686&"
import script from "./ForecastCardToxinParams.vue?vue&type=script&lang=js&"
export * from "./ForecastCardToxinParams.vue?vue&type=script&lang=js&"
import style0 from "./ForecastCardToxinParams.vue?vue&type=style&index=0&id=5160b686&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports